import { Grid, Group, Layout, Page } from "@/comn/components";
import { useFetch, useGrid, useModal, usePage, usePopup, useStore, useToast } from "@/comn/hooks";
import { comnEnvs, comnUtils } from "@/comn/utils";
import { APIS, SG_BLTBRD_MGMT_POP_LIST } from "@/tz/go/egaz/osci/ptl/sysm/bltbrd/services/OscibltbrdService";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";

/*
 * Common Code Valid Value Details
 * !== 공통 코드 유효 값 상세 ==!
 */
export const OSCI0111017Q = (props: any) => {
    const { params, callback } = props; // Parameters received from the parent screen !== 부모화면으로 부터 받은 parameter ==!
    // const {pgeUid, menuId} = usePage();
    const pgeUid = "osci0111017q";
    const { t } = useTranslation();
    const toast = useToast();
    const { close, postMessage, getParams } = usePopup();
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid });
    const [tpCdValList, setTpCdValList] = useState<tpCdValList>(); // TypeCode Value List State !== TypeCode Value List State ==!

    // Bulletin board Type Code Interface !== 게시판유형코드 ==!
    interface tpCd {
        btbdmsTpCd: string;
        btbdmsTpCdKoNm: string;
        btbdmsTpCdEnNm: string;
        btbdmsTpCdTzNm: string;
    }

    interface tpCdValList {
        content: tpCd[];
        __t: any;
    }

    const grid = {
        bltbrdList: useGrid({
            defaultSchema: SG_BLTBRD_MGMT_POP_LIST,
            page: pgeStore?.page,
            size: 100,
        }),
    };

    const fetch = {
        getbltbrdList: useFetch({
            api: (page = grid.bltbrdList.page) => APIS.getbltbrdList("", page, grid.bltbrdList.size),
            key: [grid.bltbrdList.page, grid.bltbrdList.size],
            onSuccess: () => {
                setStore(pgeUid, {
                    page: grid.bltbrdList.page,
                    size: grid.bltbrdList.size,
                });
            },
            onError: () => toast.showToast({ type: "error", content: "msg.osc.00043" }), // Failed to select. !== 조회가 실패하였습니다. ==!
        }),
    };

    const handler = {
        // Check Type code List !== 유형코드 목록 조회 ==!
        getBltbrdList: () => {
            grid.bltbrdList.setPage(0);
            fetch.getbltbrdList.fetch(0);
        },

        // Click the Apply button (Apply Parent Screen) !== 적용 버튼 클릭 (부모화면에 적용) ==!
        clickApplyBtn: () => {
            callback({ relaBltbrdList: grid.bltbrdList.getChecked() });
            close();
        },

        // Check parent screen existing selection!== 부모화면 기존선택값 체크 ==!
        chkParentVal: () => {
            console.log(params);
            // const extractedKeys: any[] = [];

            // grid.tpCdList.grid._grid.current._content.forEach((item : any) => {
            //     const currentBtbdmsTpCd = item.btbdmsTpCd;

            //     const matchedParam = params.find((param : any) => param.btbdmsTpCd === currentBtbdmsTpCd);
            //     if (matchedParam) {
            //         extractedKeys.push(item.__key);
            //     }
            // });
            // console.log(extractedKeys);
            // grid.tpCdList.grid._grid.current._checked = extractedKeys;
            // console.log(grid.tpCdList.getChecked());
            // console.log(grid.tpCdList.grid._grid.current._content);
            // console.log(grid.tpCdList.grid._grid.current._checked);
            // params.map((obj: any) => {
            //     console.log(obj);
            // })
        },
    };

    useEffect(() => {
        handler.getBltbrdList();
        handler.chkParentVal();
    }, []);

    return (
        <Page>
            <Group>
                <Group.Header>
                    <Group.Title title={t("T_BLTBRD_LST")} />
                </Group.Header>
                <Group.Body>
                    <Group.Section>
                        <Grid {...grid.bltbrdList.grid} data={fetch.getbltbrdList.data?.bltbrdList} />
                    </Group.Section>
                    <Group.Section>
                        <Layout>
                            <Layout.Right>
                                <Layout.Button role={"apply"} onClick={handler.clickApplyBtn} />
                            </Layout.Right>
                        </Layout>
                    </Group.Section>
                </Group.Body>
            </Group>
        </Page>
    );
};
